import { RenderCellProps } from 'react-data-grid';
import { CellRenderer } from './CellRenderer';

export const DomainCellRenderer = ({
  row,
  column,
}: RenderCellProps<Row>): JSX.Element => {
  const typedColumn = column as unknown as TypedColumn;
  const rowValue = row[column.key];
  if (rowValue === undefined || rowValue === null) return <CellRenderer />;

  return (
    <CellRenderer>
      {typedColumn.field.domain?.codedValues?.find(
        (v) => v.code?.toString() === rowValue.toString()
      )?.name ?? ''}
    </CellRenderer>
  );
};
